const AccountDetail = () => {
  return <>AccountDetail</>;
};

export default AccountDetail;
